import { createFileRoute, redirect } from "@tanstack/react-router";
import { type AppConfig, api } from "../lib/api.ts";

/**
 * Legacy-platform route. The UI moved to /app/$customerId/... when the Qwik
 * platform's layout was ported; this keeps old links working.
 */
export const Route = createFileRoute("/orders")({
  beforeLoad: async ({ context }) => {
    const config = await context.queryClient.ensureQueryData({
      queryKey: ["config"],
      queryFn: () => api.get<AppConfig>("/config"),
    });
    if (!config.user) throw redirect({ to: "/sign-in" });
    throw redirect({ to: "/app/$customerId/myorders", params: { customerId: config.user.id } });
  },
  component: () => null,
});
